module.exports = __webpack_public_path__ + "img/ftw_logo_white.a9a5c327.png";